import axios from 'axios';

/**
 * Start AI extract/rewrite from a CV already stored after ATS upload.
 *
 * @param {{ sourceCvId: string|number, jobPosition?: string }} options
 * @returns {Promise<import('axios').AxiosResponse>}
 */
export const rewriteCvFromStoredFile = ({ sourceCvId, jobPosition = '' }) => {
  const id = String(sourceCvId);
  const payload = {
    ai_consent: true,
    source_cv_id: id,
  };
  const job = (jobPosition || '').trim();
  if (job) {
    payload.job_position = job;
  }
  return axios.post(
    `/api/cvs/analyze-pdf/?source_cv_id=${encodeURIComponent(id)}`,
    payload,
  );
};
